module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/vendor/vendor.component.css
// module id = ./src/app/Pages/manage/vendor/vendor.component.css
// module chunks = main